<template>
  <button
    type="button"
    class="rounded bg-transparent text-neutral-400 outline-none hover:text-neutral-600 focus:text-neutral-600 dark:text-neutral-400 dark:hover:text-neutral-300 dark:focus:text-neutral-300"
  >
    <Icon icon="XSolid" class="size-6 sm:size-5" />
  </button>
</template>
